import { call } from 'redux-saga/effects';
import { dispatch } from '@restore/helpers';
import { detachRpcScheme } from 'src/services/rpc/detach/scheme';
import { formManagementSlice } from '@restore/readerViewerSession/formManagement/formManagement.slice';
import { ChangeScoringFormDataAction } from '@restore/readerViewerSession/formManagement/formManagement.types';
import { selectTabCoordinationState } from '@restore/readerViewerSession/utils';

const { setFormReadyToSubmit } = formManagementSlice.actions;

/**
 * The reader edited the form.
 *
 * In a detached window the edit also has to reach the main tab: that tab owns
 * the reading, re-mounts the form on re-attach and is what a later save reads
 * from, so it must hold the current values rather than the snapshot taken when
 * the window was popped out. `detachRpcScheme.events.formChanged` is silent in
 * the main tab itself, so this cannot loop back.
 */
export function* changeScoringFormDataWorker(
  action: ChangeScoringFormDataAction
) {
  const { isValid } = action.payload;

  yield dispatch(setFormReadyToSubmit(isValid));

  const { isDetached, mainTab } = yield* selectTabCoordinationState();

  if (isDetached && !mainTab) {
    yield call(detachRpcScheme.events.formChanged, action.payload);
  }
}
